import { OnInit, OnDestroy, Component, HostListener, Inject, Optional } from '@angular/core';
import { Subscription } from 'rxjs';
import { NxiRestService } from '../../../services/NXI-Rest.service';
import { AwrAccountContextValue, AwrDomainContext, AWRContextService, AWRContextUtils } from '@pershing/nxi-core';
declare let dojoApp: any;

@Component({
    selector: 'dojo-awr-account-picker',
    templateUrl: './awr-account-picker.component.html'
})
export class DojoAwrAccountPickerComponent implements OnInit, OnDestroy {
    account: string = '';
    domain: string = '';
    goToTab: string = '';
    timPeriod: string = '';
    subs: Subscription;
    isADA: boolean;
    isMobile: boolean;
    dataFromStorage: any ;
    acctRef: any;
    prevAcctRef: any;
    setpreviousConetxt: boolean;
    constructor(
        private awrContextService: AWRContextService,
        private nxiRestService: NxiRestService, @Optional() @Inject('AppSettings') appSettings: any) {
            if (appSettings.themeType === 'ada') {
                this.isADA = true;
            }
            if (appSettings.deviceType === 'mobile') {
                this.isMobile = true;
            }
    }

    ngOnInit() {
        // this.subs = this.awrContextService.selectedAwrDomainContext$.subscribe((awrDomainContext: AwrDomainContext<any>) => {
        //     let contextValue = AWRContextUtils.getContextFromDomainValue(awrDomainContext);
        //     this.account = contextValue.accountNumber;
        //     this.goToTab = contextValue.goToTab;
        //     this.timPeriod = contextValue.timPeriod;

        // topic.publish("/awr-portfolioplus/currentAccount")
        // if (sessionStorage.getItem('awrAccount')) {
        //     this.prevAcctRef = sessionStorage.getItem('awrAccount');
        // }
        // below line is to handle the refresh or back from od screen. If the context is empty try to get from local storage and set the avlues in context
        // this.subs = this.awrContextService.selectedAwrDomainContext$.subscribe((awrDomainContext: AwrDomainContext<any>) => {
        //     let contextValue = AWRContextUtils.getContextFromDomainValue(awrDomainContext);
        //     if (contextValue.accountNumber === '') {
        //         this.dataFromStorage = JSON.parse(localStorage.getItem('awrDataContext'));
        //         console.log(this.dataFromStorage);
        //         this.setpreviousConetxt = true;

        //     }
        //     console.log(contextValue.accountNumber);
        //     console.log(contextValue.timePeriod);
        // });
        this.getAwrAccountPicker();
       // });
    }

    @HostListener('document:awr.gotoview', ['$event'])
    gotoEvent(event: any) {
        // from timeperiod dont pass the account number
        if (!event.detail.accountNumber) {
            this.subs = this.awrContextService.selectedAwrDomainContext$.subscribe((awrDomainContext: AwrDomainContext<any>) => {
                let contextValue = AWRContextUtils.getContextFromDomainValue(awrDomainContext);
                event.detail.accountNumber = contextValue.accountNumber;
            });
         }
        // let awrAccountContextValue: AwrAccountContextValue
        if (window['require']) {
            let topic = window['require']('dojo/topic');
            // && !this.isMobile
            if (!this.isADA && !event.detail.directAcctChange) {
                this.subs = this.awrContextService.selectedAwrDomainContext$.subscribe((awrDomainContext: AwrDomainContext<any>) => {
                let contextValue = AWRContextUtils.getContextFromDomainValue(awrDomainContext);
                if (contextValue.accountNumber === '') {
                    topic.publish('/awr-portfolioplus/currentAccount', { 'accountNumber' : event.detail.accountNumber,
                    'goToTab' : event.detail.goToTab, 'timePeriod': event.detail.timeperiod});
                    let awrAccountContextValue: AwrAccountContextValue = new AwrAccountContextValue(event.detail.accountNumber,
                        event.detail.timeperiod, event.detail.goToTab, event.detail.awrAccount);
                    this.awrContextService.setAwrDomainContext('account', awrAccountContextValue);
                    if (this.isMobile) {
                        topic.publish('/awr-portfolioplus/current-active-tab', {'tabId': event.detail.goToTab });
                    }
                } else {
                    topic.publish('/awr-portfolioplus/currentAccount', { 'accountNumber' : contextValue.accountNumber,
                    'goToTab' : contextValue.goToTab, 'timePeriod': contextValue.timePeriod});
                    if (this.isMobile) {
                        topic.publish('/awr-portfolioplus/current-active-tab', {'tabId': contextValue.goToTab });
                    }
                }
            });
    } else {
        let awrAccountContextValue: AwrAccountContextValue = new AwrAccountContextValue(event.detail.accountNumber,
            event.detail.timeperiod, event.detail.goToTab, event.detail.awrAccount);
        this.awrContextService.setAwrDomainContext('account', awrAccountContextValue);
        if (this.isMobile) {
            topic.publish('/awr-portfolioplus/current-active-tab', {'tabId': event.detail.goToTab });
        }
    }
}
        if (this.setpreviousConetxt) {
            this.setpreviousConetxt = false;
            document.dispatchEvent(new CustomEvent('awr.gotoview', {
                detail: {
                    'awrAccount': this.dataFromStorage.awrAccount,
                    'timeperiod': this.dataFromStorage.timePeriod,
                    'goToTab' : this.dataFromStorage.goToTab,
                    'accountNumber': this.dataFromStorage.accountNumber
                }
            }));
        }
    }

    ngOnDestroy(): void {
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.destroyAwrAccountPicker();
        }
    }
    renderDojoWidget(awrAccountPickerDojoParams: any) {
        if (dojoApp) {
           dojoApp.renderAwrAccountPicker(awrAccountPickerDojoParams);
        }
    }

    getAwrAccountPicker() {
        if (this.acctRef !== '') {
            this.nxiRestService.getNxiPortfolioRestResponse(this.acctRef, 'awrAccountPicker').subscribe(
                resp => {
                    console.log('Retrived Portfolio AWR Account Picker params : ', resp.response);
                    if (resp.response) {
                        resp.response.storeUrl = this.nxiRestService.serviceUrl + resp.response.storeUrl;
                        this.renderDojoWidget(resp.response);
                    }
                }
            );
        }
    }

    openlimitedAcctDialog () {
        dojoApp.renderLimitDataDialogue();
    }

    gotoTop() {
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }
}
